module.exports = __webpack_public_path__ + "static/media/IntellectualProperty.c62c641e.jpg";